/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ClusterStates } from 'shared';

import { clusterStatusColors } from '../constants/clusterStatusColors';

export const determineStatusColor = (status?: ClusterStates): string => {
  return status ? clusterStatusColors[status] : clusterStatusColors.__fallback;
};
